"use client";

import { Button, Icon, TextField } from "@justhome/react-ui";
import type { Locale } from "@lib/i18n/locale";
import {
  MIN_QUERY_LENGTH,
  useHubSearch,
} from "@modules/hub/components/HubSearch";
import { GRID_ANCHORS } from "@modules/hub/lib/hubPath";
import { useTranslations } from "next-intl";

const HeroSearch = ({ locale }: { locale: Locale }) => {
  const t = useTranslations("hub");
  const { query, submit } = useHubSearch();

  return (
    <form
      role="search"
      aria-label={t("search_label")}
      onSubmit={(event) => {
        event.preventDefault();
        submit(String(new FormData(event.currentTarget).get("query")));
        document
          .getElementById(GRID_ANCHORS[locale])
          ?.scrollIntoView({ block: "start" });
      }}
      className="flex gap-2xs w-full max-w-[560px]"
    >
      {/* Keyed by the running search, so a reset in the list or a restored address refills it. */}
      <TextField
        key={query}
        name="query"
        type="search"
        defaultValue={query}
        placeholder={t("search_placeholder")}
        aria-label={t("search_label")}
        minLength={MIN_QUERY_LENGTH}
        autoComplete="off"
        enterKeyHint="search"
        prefix={<Icon type="Search" size={20} fill="currentColor" />}
      />
      <Button
        type="submit"
        size="md"
        className="flex-none !w-auto"
        data-tracking-event="Hub - Search"
      >
        {t("search_submit")}
      </Button>
    </form>
  );
};

export default HeroSearch;
